
import gql from 'graphql-tag';

const ADD_LEAD_FOLLOW_UP = gql` 
  mutation addLeadFollowUp($input: LeadFollowUpInput!) {
    addLeadFollowUp(input: $input) {
      message
      code
    }
  }
`;

export default ADD_LEAD_FOLLOW_UP;
